import { useEffect, useState } from 'react';

/**
 * 주의: getEventList 로 받아온 이벤트 리스트의 remainDay는 디데이가 남았다면 음수값으로 보내줌.
 */
export default function useMakeDdayString(remainDay: number): string {
  const [dDay, setDDay] = useState('');

  useEffect(() => {
    const newDDay = +remainDay > 0 ? '종료' : `D${remainDay}`;
    setDDay(newDDay);
  }, [remainDay]);

  return dDay;
}
